import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { bool_type, class_type, int32_type, list_type, string_type, record_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { SKU_$reflection, ISBN_$reflection, OLID_$reflection, FSID_$reflection } from "./Common.js";
import { Guards_GuardCriteria_get_None, Guards_GuardCriteria_Create_71C5AF32 } from "./Errors.js";

export class Provider extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FakeStore", "OpenLibrary"];
    }
}

export function Provider_$reflection() {
    return union_type("Shopfoo.Domain.Types.Catalog.Provider", [], Provider, () => [[], []]);
}

export class BazaarCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Clothing", "Electronics", "Jewelry"];
    }
}

export function BazaarCategory_$reflection() {
    return union_type("Shopfoo.Domain.Types.Catalog.BazaarCategory", [], BazaarCategory, () => [[], [], []]);
}

export class BazaarProduct extends Record {
    constructor(FSID, Category) {
        super();
        this.FSID = FSID;
        this.Category = Category;
    }
}

export function BazaarProduct_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.BazaarProduct", [], BazaarProduct, () => [["FSID", FSID_$reflection()], ["Category", BazaarCategory_$reflection()]]);
}

export class BookAuthor extends Record {
    constructor(OLID, Name) {
        super();
        this.OLID = OLID;
        this.Name = Name;
    }
}

export function BookAuthor_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.BookAuthor", [], BookAuthor, () => [["OLID", OLID_$reflection()], ["Name", string_type]]);
}

export class BookAuthorSearchResults extends Record {
    constructor(Authors, TotalCount) {
        super();
        this.Authors = Authors;
        this.TotalCount = (TotalCount | 0);
    }
}

export function BookAuthorSearchResults_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.BookAuthorSearchResults", [], BookAuthorSearchResults, () => [["Authors", list_type(BookAuthor_$reflection())], ["TotalCount", int32_type]]);
}

export class SearchedBook extends Record {
    constructor(EditionKey, Title, Subtitle, Authors) {
        super();
        this.EditionKey = EditionKey;
        this.Title = Title;
        this.Subtitle = Subtitle;
        this.Authors = Authors;
    }
}

export function SearchedBook_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.SearchedBook", [], SearchedBook, () => [["EditionKey", OLID_$reflection()], ["Title", string_type], ["Subtitle", string_type], ["Authors", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [BookAuthor_$reflection()])]]);
}

export class BookSearchResults extends Record {
    constructor(Books, TotalCount) {
        super();
        this.Books = Books;
        this.TotalCount = (TotalCount | 0);
    }
}

export function BookSearchResults_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.BookSearchResults", [], BookSearchResults, () => [["Books", list_type(SearchedBook_$reflection())], ["TotalCount", int32_type]]);
}

export class Book extends Record {
    constructor(ISBN, Subtitle, Authors, Tags) {
        super();
        this.ISBN = ISBN;
        this.Subtitle = Subtitle;
        this.Authors = Authors;
        this.Tags = Tags;
    }
}

export function Book_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.Book", [], Book, () => [["ISBN", ISBN_$reflection()], ["Subtitle", string_type], ["Authors", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [BookAuthor_$reflection()])], ["Tags", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])]]);
}

export class Category extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Bazaar", "Books"];
    }
}

export function Category_$reflection() {
    return union_type("Shopfoo.Domain.Types.Catalog.Category", [], Category, () => [[["Item", BazaarProduct_$reflection()]], [["Item", Book_$reflection()]]]);
}

export class ImageUrl extends Record {
    constructor(Url, Broken) {
        super();
        this.Url = Url;
        this.Broken = Broken;
    }
}

export function ImageUrl_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.ImageUrl", [], ImageUrl, () => [["Url", string_type], ["Broken", bool_type]]);
}

export function ImageUrl_Valid_Z721C83C5(url) {
    return new ImageUrl(url, false);
}

export function ImageUrl_get_None() {
    return new ImageUrl("", true);
}

export class Product extends Record {
    constructor(SKU, Title, Description, Category, ImageUrl) {
        super();
        this.SKU = SKU;
        this.Title = Title;
        this.Description = Description;
        this.Category = Category;
        this.ImageUrl = ImageUrl;
    }
}

export function Product_$reflection() {
    return record_type("Shopfoo.Domain.Types.Catalog.Product", [], Product, () => [["SKU", SKU_$reflection()], ["Title", string_type], ["Description", string_type], ["Category", Category_$reflection()], ["ImageUrl", ImageUrl_$reflection()]]);
}

export const ProductModule_Guard_SKU = Guards_GuardCriteria_Create_71C5AF32("SKU", undefined, undefined, true);

export const ProductModule_Guard_Name = Guards_GuardCriteria_Create_71C5AF32("Name", 128, undefined, true);

export const ProductModule_Guard_Description = Guards_GuardCriteria_Create_71C5AF32("Description", 512);

export const ProductModule_Guard_BookSubtitle = Guards_GuardCriteria_Create_71C5AF32("BookSubtitle", 256);

export const ProductModule_Guard_ImageUrl = Guards_GuardCriteria_get_None();

